import React, { useEffect, useState } from "react";
import TextInput from "../../Common/FormElements/TextInput/TextInput";
import { useTranslation } from "react-i18next";
import Select from "../../Common/FormElements/Select/Select";
import Button from "../../Common/FormElements/Button/Button";
import { useDispatch, useSelector } from "react-redux";
import { updateDelivery } from "../../../REDUX/actions/delivery";
import { statusOptions } from "../useDeparture";

const DepartureInvoice = () => {
  const { t } = useTranslation("common");
  const { delivery } = useSelector((state) => state.deliveryReducer);
  const { user } = useSelector((state) => state.userReducer);
  const dispatch = useDispatch();
  const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    const { value, name } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleClick = () => {
    dispatch(
      updateDelivery(delivery?.id, {
        ...formData,
        deliveryStatus: formData.deliveryStatus?.code,
      })
    );
  };

  useEffect(() => {
    setFormData({
      price: delivery?.attributes?.price,
      invoiceNumber: delivery?.attributes?.invoiceNumber,
      deliveryStatus: [
        ...statusOptions(t),
        {
          name: t("INVOICED"),
          code: "INVOICE",
        },
      ].find((option) => option.code === delivery?.attributes?.deliveryStatus),
    });
  }, [delivery, t]);

  return (
    <div className="d-flex flex-column text-dark position-relative text-break">
      <span className="mb-3 f16 sBold">{t("Summary of invoice")}</span>
      <p className="f16">
        {t(
          "In order to facilitate our invoicing follow-up, we kindly ask that for each delivery confirmation you indicate the delivery cost excluding tax (excl. VAT)."
        )}
      </p>
      <div className="d-flex flex-column mt-4 max-w-300px mb-5">
        <p className="mb-2 f14">{t("Delivery amount excl. tax")}</p>
        <TextInput
          name="price"
          defaultValue={delivery?.attributes?.price}
          disabled={user?.attributes?.userRole !== 4}
          value={formData.price}
          placeholder="0"
          callback={handleChange}
        />
      </div>

      <p className="f16 mb-4">
        {t(
          "The information below is filled in by the admin of Poseidon Spa to track the invoice for each delivery number completed by your team."
        )}
      </p>
      <div className="d-flex gap-4">
        <div className="d-flex flex-column mt-4 max-w-300px mb-5">
          <p className="mb-2 f14">{t("Invoice Status")}</p>
          <Select
            name="deliveryStatus"
            disabled={
              !["DELIVERED", "INVOICE"]?.includes(
                delivery?.attributes?.deliveryStatus
              ) || user?.attributes?.userRole !== 1
            }
            value={formData.deliveryStatus}
            placeholder={
              statusOptions(t).find(
                (option) => option.code === delivery?.attributes?.deliveryStatus
              )?.name
            }
            options={[
              ...statusOptions(t).filter((option) =>
                ["DELIVERED", "INVOICE"].includes(option.code)
              ),
              { name: t("INVOICED"), code: "INVOICE" },
            ]}
            callback={handleChange}
          />
        </div>
        <div className="d-flex flex-column mt-4 max-w-300px mb-5">
          <p className="mb-2 f14">{t("Invoice Number")}</p>
          <TextInput
            name="invoiceNumber"
            disabled={user?.attributes?.userRole !== 1}
            placeholder=""
            defaultValue={delivery?.attributes?.invoiceNumber}
            value={formData?.invoiceNumber}
            callback={handleChange}
          />
        </div>
      </div>
      <div>
        <Button onClick={handleClick}>{t("Save")}</Button>
      </div>
    </div>
  );
};

export default DepartureInvoice;
